// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
    suggestionMobileStyle: 'style2'
  }
};

(function () {
  /* This is to inject boost components into this scope, so we can override component's function */
  BoostPFS.inject(this);
  
  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function() {};
  

  SearchInput.prototype.onOpenAutocomplete = function(event, autocompleteUi) {
      // Prevent double tap on iOS
      if (Utils.isiOS()) {
        jQ('.' + Class.searchSuggestionItem + ' a')
        .on('touchstart', () => {
            this.isScrolling = false;
            })
        .on('touchmove', () => {
            this.isScrolling = true;
            })
        .on('touchend', () => {
            if (!this.isScrolling) {
          window.location = jQ(this).attr('href');
        }
      });
    }
    // On mobile, prevent body from scrolling if it is full Instant search result style
    if (Utils.InstantSearch.isFullWidthMobile() && !jQ('body').hasClass(Class.searchSuggestionMobileOpen)) {
      jQ('body').addClass(Class.searchSuggestionMobileOpen);
    }
    this.instantSearchResult.$wrapper.addClass(Class.searchSuggestionOpen);
    jQ('body').addClass('boost-pfs-search-open');
    jQ('html').addClass('boost-pfs-search-open');
  }

   SearchInput.prototype.onCloseAutocomplete = function(event, autocompleteUi) {
    /**
           * Test Mode - Turn on when need check elements of Auto Complete
           * Prevent closing Auto complete when opening Inspect Element
           */
    if (Settings.getSettingValue('search.suggestionMode') == 'test' || Utils.InstantSearch.isFullWidthMobile()) {
      this.instantSearchResult.$instantSearchResult.show();
    } else {
      this.instantSearchResult.$instantSearchResult.siblings().hide();
    }
    this.instantSearchResult.$wrapper.removeClass(Class.searchSuggestionOpen);
    jQ('body').removeClass('boost-pfs-search-open');
    jQ('html').removeClass('boost-pfs-search-open');
  }
  
})();



// Only send Weglot request if the current language is different from English
function isWeglotActive() {
    if (!window.Weglot || !window.Weglot.initialized) {
      	return false;
    } else {
    	var currentLang = Weglot.getCurrentLang();
	// Change 'en' to suitable with original language of the store
    	return currentLang !== 'en';
    }
}
  
 InstantSearchApi.beforeCallAsync = function(searchTerm, callInstantSearchApi) {
    // Then use it in our API
    if (window.Weglot && window.Weglot.initialized && isWeglotActive()) {
        Weglot.search(searchTerm, function(englishTerm) {
		Globals.instantSearchQueryParams['q'] = englishTerm;
        	callInstantSearchApi();
       	});
    } else {
        callInstantSearchApi();
    }
}